<template>
  <DialogLayout :show-close="false" :class-name="'no-access-permission-dialog'" @close="handleClose">
    <template #default>
      <div class="no-access-content">
        <div class="icon-wrapper">
          <img class="e-img" src="@/assets/images/no-access.png" />
        </div>
        <div v-if="message" class="message-text">{{ message }}</div>
        <div v-if="tips" class="tips-text">{{ tips }}</div>
      </div>
      <div class="btn">
        <el-button
          class="confirm-button"
          v-bind="confirmButtonProps"
          @click="handleConfirm"
        >
          {{ confirmButtonText }} 
        </el-button>
      </div>
    </template>
  </DialogLayout>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import DialogLayout from '@/components/business-components/dialog/dialog-layout.vue';
import { useI18n } from 'vue-i18n';
import {
  type NoAccessPermissionModalProps
} from './no-access-permission-types'

const props = withDefaults(
  defineProps<NoAccessPermissionModalProps>(),
  {
    message: '',
    confirmButtonText: '',
    confirmButtonProps: () => ({ type: 'primary' }),
  }
);

const emit = defineEmits<{
  confirm: [];
  close: [];
}>();

const { t } = useI18n();

const message = computed(() => props.message || t('common.noAccessPermission'));
const confirmButtonText = computed(() => props.confirmButtonText || t('common.ok'));

const handleConfirm = () => {
  emit('confirm');
};

const handleClose = () => {
  emit('close');
};
</script>

<style lang="scss" scoped>
.no-access-permission-dialog {
  min-width: 260px;
  min-height: 272px;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  :deep(.dialog-footer) {
    padding: 0;
  }
}
:deep(.dialog-header) {
  padding: 0;
}
:deep(.dialog-content) {
  padding: 0;
  min-width: 260px;
  min-height: 272px;;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.no-access-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.icon-wrapper {
  width: 100%;
  height: 122px;
  margin-bottom: 22px;
  .e-img {
    width: 100%;
    height: 100%;
  }
}

.no-access-icon {
  // width: 64px;
  // height: 64px;
}

.message-text {
  font-size: 16px;
  line-height: 24px;
  color: #3D3D3D;
  font-weight: 500;
  text-align: center;
  margin-bottom: 8px;
}
.tips-text {
  font-size: 12px;
  font-weight: normal;
  line-height: 20px;
  color: #88929B;
  margin-bottom: 13px;
}
.btn {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
}
.confirm-button {
  min-width: 80px;
  height: 36px;
  padding: 8px 24px;
  font-size: 14px;
  line-height: 20px;
  border-radius: 6px;
  // margin-top: 24px;
  margin-bottom: 30px;
}
</style>
